export default __webpack_public_path__ + "static/media/basic.ee8f5cba.png";